module.exports = __webpack_public_path__ + "img/FAIRSPIN.2829e729.svg";